export const INITIAL_STATE = {
	id: null,
	season: null,
	theme: null,
	designedBy: null,
	brand: null,
	tag: [],
	imageId: null,
	fileId: null,
	comments: '',
	fileName: 'SS4 fashion-trand_1748498369094'
};

export const ARTWORK_TAG_TYPES = {
	ARTWORK_SEASON_TAG: 'ARTWORK_SEASON_TAG',
	ARTWORK_THEME_TAG: 'ARTWORK_THEME_TAG',
	ARTWORK_TAGS: 'ARTWORK_TAGS'
};

export const ASSETS_TABS = {
	BLOCK_LIBRARY: 'BLOCK_LIBRARY',
	SKETCH: 'SKETCH',
	ARTWORK: 'ARTWORK'
};

export const DOC_TYPE = {
	ASSETS_IMAGE_S1: 'ASSETS_IMAGE_S1',
	ASSETS_IMAGE_S2: 'ASSETS_IMAGE_S2',
	ASSETS_IMAGE_S3: 'ASSETS_IMAGE_S3',
	ASSETS_IMAGE_S4: 'ASSETS_IMAGE_S4'
};

export const TAG_COLORS = [
	'#EDE3FE',
	'#FBD9C2',
	'#FFEAEA',
	'#DBFFE5',
	'#FEEAC1',
	'#D0F0FD',
	'#F4DBE6',
	'#EDDBD5',
	'#FFD66E',
	'#C2F5E9'
];
